export const setupOidcSessionStorageSanitizer = () => {
  const authority = localStorage.getItem("oidc.authority")
  const clientId = localStorage.getItem("oidc.clientId")

  if (!authority || !clientId) {
    return
  }

  if ((setupOidcSessionStorageSanitizer as { initialized?: boolean }).initialized) {
    return
  }

  ;(setupOidcSessionStorageSanitizer as { initialized?: boolean }).initialized = true

  const oidcStorageKey = `oidc.user:${authority}:${clientId}`
  const originalSetItem = sessionStorage.setItem.bind(sessionStorage)
  let isSanitizing = false

  const sanitizeOidcSessionEntry = () => {
    const oidcStorage = sessionStorage.getItem(oidcStorageKey)

    if (!oidcStorage) {
      return
    }

    try {
      const parsed = JSON.parse(oidcStorage)

      if (typeof parsed.scope === "string") {
        const sanitizedScope = parsed.scope
          .split(" ")
          .filter(
            (scopePart: string) =>
              scopePart.trim() !== "" &&
              scopePart !== "offline_access" &&
              !scopePart.includes("/User.Read")
          )
          .join(" ")

        if (sanitizedScope !== parsed.scope) {
          parsed.scope = sanitizedScope
          isSanitizing = true
          originalSetItem(oidcStorageKey, JSON.stringify(parsed))
          isSanitizing = false
        }
      }
    } catch (error) {
      console.warn("Failed to sanitize oidc.user entry in sessionStorage", error)
    }
  }

  sessionStorage.setItem = (key: string, value: string) => {
    originalSetItem(key, value)

    if (!isSanitizing && key === oidcStorageKey) {
      sanitizeOidcSessionEntry()
    }
  }

  window.addEventListener("storage", (event) => {
    if (event.storageArea === sessionStorage && event.key === oidcStorageKey) {
      sanitizeOidcSessionEntry()
    }
  })

  sanitizeOidcSessionEntry()
}
